import { Link } from "react-router-dom";
import SEO from '../pages/SEO';
import { Button } from "../ui/button"
import { Card, CardContent } from "../ui/card"
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import { useState } from "react"; 
import InsuranceSection from "../components/InsuranceSection.js"



import {
  Phone,
  Mail,
  MapPin,
  CheckCircle2,
  Users,
  Award,
  Heart,
  Stethoscope,
  Shield,
  ChevronLeft,
  ChevronRight,
} from "lucide-react"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion"

export default function ENTLandingPage() {
  const navigate = useNavigate();

  /* ---------------- FORM STATE ---------------- */
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    dob: "",
    visitType: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_mfxrmqm",
        "template_0h1j6o6", // 🔁 replace with real template ID
        {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          gender: formData.gender,
          dob: formData.dob,
          visit_type: formData.visitType,
        },
        "EQIu7gTx1Ns0SiRpq" // 🔁 replace with real public key
      )
      .then(() => {
        alert("Appointment booked successfully!");
        navigate("/");
      })
      .catch(() => {
        alert("Submission failed. Please try again.");
      });
  };




  const [activeTab, setActiveTab] = useState("ear")
  const [currentSlide, setCurrentSlide] = useState(0)
    const isMobile = window.innerWidth < 768;

  const earConditions = [
    { name: "Ear Pain & Infections", link: "#" },
    { name: "Hearing Loss & Deafness", link: "#" },
    { name: "Tinnitus (Ringing in Ears)", link: "#" },
    { name: "Vertigo & Balance Disorders", link: "#" },
    { name: "Ear Wax Removal", link: "#" },
    { name: "Middle Ear Infections", link: "#" },
    { name: "Swimmer's Ear", link: "#" },
    { name: "Ear Foreign Bodies", link: "#" },
    { name: "Sudden Hearing Loss (SSHL)", link: "#" },
    { name: "TMJ Dysfunction", link: "#" },
    { name: "Facial Paralysis", link: "#" },
  ]

  const noseConditions = [
    { name: "Allergic Rhinitis", link: "#" },
    { name: "Sinusitis with Polyps", link: "#" },
    { name: "Sinusitis without Polyps", link: "#" },
    { name: "Deviated Nasal Septum", link: "#" },
    { name: "Nose Bleeds (Epistaxis)", link: "#" },
    { name: "Nasal Obstruction", link: "#" },
    { name: "Sinus/Nasal Tumors", link: "#" },
    { name: "Nasal Trauma", link: "#" },
    { name: "Nose Foreign Bodies", link: "#" },
    { name: "Watering Eyes (Epiphora)", link: "#" },
    { name: "Vasomotor Rhinitis", link: "#" },
  ]

  const throatConditions = [
    { name: "Tonsillitis & Tonsillectomy", link: "#" },
    { name: "Adenoid Problems", link: "#" },
    { name: "Throat Infections", link: "#" },
    { name: "Voice Disorders", link: "#" },
    { name: "Thyroid Surgery", link: "#" },
    { name: "Salivary Gland Disorders", link: "#" },
    { name: "Laryngeal Foreign Body", link: "#" },
    { name: "Quinsy (Abscess)", link: "#" },
    { name: "Tongue Tie Release", link: "#" },
    { name: "Tongue Biopsy", link: "#" },
    { name: "Tracheostomy", link: "#" },
    { name: "Lymph Node Biopsies", link: "#" },
  ]

  const whyChoose = [
    {
      icon: Users,
      title: "Experienced ENT Surgeons & Specialists",
      description: "Highly trained doctors with years of ENT expertise",
    },
    {
      icon: Stethoscope,
      title: "Advanced Endoscopic ENT Procedures",
      description: "Minimally invasive surgeries for faster recovery",
    },
    {
      icon: Award,
      title: "Modern Audiology & Diagnostics",
      description: "Complete hearing and balance assessments",
    },
    {
      icon: Heart,
      title: "Child-Friendly Pediatric ENT Care",
      description: "Safe, comfortable treatment for children",
    },
    {
      icon: CheckCircle2,
      title: "Comprehensive Allergy & Sinus Care",
      description: "Diagnosis and long-term management",
    },
    {
      icon: Shield,
      title: "All Insurance Accepted",
      description: "Cashless treatment for eligible patients",
    },
  ]

  const specialists = [
    {
      name: "Dr Ahmed Abdul Majid Hussaini",
    //   specialty: "Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
      description: "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
      image: "/1 Dr Ahmed Abdul Majid Hussaini.jpg",
    },
    {
    name: "Dr Uma Pokala",
   // specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/2 Dr Uma Pokala.jpg",
  },
  {
    name: "Dr Maryada Sravani",
   //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/Dr Maryada Sravani.jpg",
  },
  {
    name: "Dr Sivapuram Kavya",
   //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/3 Dr Sivapuram Kavya.jpg",
  },
  {
    name: "Dr Pasunooti Shravya",
   // specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/Dr Pasunooti Shravya.jpg",
  },
  {
    name: "Dr Surabhi Periwal",
    //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/4 Dr Surabhi Periwal.jpg",
  },
  ]

const faqs = [
  {
    question: "Do you perform endoscopic sinus surgery?",
    answer:
      "Yes, we perform advanced endoscopic sinus surgery (FESS) using minimally invasive techniques for faster recovery.",
  },
  {
    question: "Can hearing loss be treated?",
    answer:
      "Yes. Depending on the cause, hearing loss can be treated medically, surgically, or with hearing aids.",
  },
  {
    question: "Do you provide pediatric ENT services?",
    answer:
      "Yes, we offer specialized ENT care for children including tonsils, adenoids, and ear infections.",
  },
  {
    question: "Is Aarogyasri accepted?",
    answer:
      "Yes, Aarogyasri and other government health schemes are accepted for eligible patients.",
  },
  {
    question: "What are your consultation timings?",
    answer:
      "Monday to Saturday, 9:00 AM to 8:00 PM. Emergency services are available 24/7.",
  },
]


  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

 const visibleCards = isMobile ? 1 : 3

const maxSlide = Math.max(specialists.length - visibleCards, 0)


const nextSlide = () => {
  setCurrentSlide((prev) => Math.min(prev + 1, maxSlide))
}

const prevSlide = () => {
  setCurrentSlide((prev) => Math.max(prev - 1, 0))
}


  const totalDots = specialists.length - 2




  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Best ENT Hospital in Hyderabad | Ear Nose Throat Specialists | MAMS Hospitals"
        description="Expert ENT treatment in Bachupally, Miyapur Hyderabad. Advanced ear, nose & throat care with minimally invasive procedures. Book an ENT consultation at MAMS Hospitals."
        keywords="best ENT hospital Hyderabad, ENT specialist Bachupally, ear nose throat doctor Hyderabad, ENT hospital Miyapur, sinus surgery Hyderabad, tonsil treatment Hyderabad"
        canonicalUrl="https://mamshospitals.com/ent-hospital-hyderabad"
      />
        <section className="bg-gradient-to-r from-teal-600 to-blue-600 py-20">
        <div className="container mx-auto px-4 max-w-7xl">

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">

            {/* 1️⃣ CONTENT CONTAINER */}
            <div className="text-white">
                <h1 className="text-4xl font-bold mb-6">
                Best ENT Hospital in Hyderabad
                </h1>
                <p className="text-lg mb-4">
                Expert ENT Treatment & Specialists in Bachupally,Miyapur.
                </p>
                <p className="text-white/90 leading-relaxed mb-6">
                Advanced diagnosis and treatment for ear, nose & throat disorders with
                minimally invasive procedures for faster recovery and long-term relief.
                </p>

                <a href="tel:+917399999981">
                <Button className="bg-white text-teal-600">
                    Call Now
                </Button>
                </a>
            </div>

            {/* 2️⃣ IMAGE CONTAINER */}
            <div className="relative h-[420px] rounded-2xl overflow-hidden shadow-2xl bg-white">
                <img
                src="/ENT.webp"
                alt="ENT Specialist"
                className="w-full h-full object-cover"
                />
            </div>

         
                    </div>
                    </div>
                    </section>




     {/* Statistics Section */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">15+</div>
              <div className="text-gray-600 font-medium">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">5000+</div>
              <div className="text-gray-600 font-medium">ENT Surgeries</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">10000+</div>
              <div className="text-gray-600 font-medium">Treated Patients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">98%</div>
              <div className="text-gray-600 font-medium">Success Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Conditions Section with Tabs */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Comprehensive ENT Care at MAMS Hospital
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Expert diagnosis and treatment for all ear, nose, throat, and head-neck conditions
            </p>
          </div>
         

          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <Button
                onClick={() => setActiveTab("ear")}
                className={`!transition-none !shadow-none rounded-full px-8 ${
                    activeTab === "ear"
                    ? "!bg-teal-600 !text-white hover:!bg-teal-600 hover:!text-white"
                    : "!bg-white !text-gray-700 border border-gray-300 hover:!bg-white hover:!text-gray-700"
                }`}
                >
                Ear Conditions
                </Button>

                <Button
                onClick={() => setActiveTab("nose")}
                className={`!transition-none !shadow-none rounded-full px-8 ${
                    activeTab === "nose"
                    ? "!bg-teal-600 !text-white hover:!bg-teal-600 hover:!text-white"
                    : "!bg-white !text-gray-700 border border-gray-300 hover:!bg-white hover:!text-gray-700"
                }`}
                >
                Nose & Sinus
                </Button>

                <Button
                onClick={() => setActiveTab("throat")}
                className={`!transition-none !shadow-none rounded-full px-8 ${
                    activeTab === "throat"
                    ? "!bg-teal-600 !text-white hover:!bg-teal-600 hover:!text-white"
                    : "!bg-white !text-gray-700 border border-gray-300 hover:!bg-white hover:!text-gray-700"
                }`}
                >
                Throat & Head-Neck
                </Button>


          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            {activeTab === "ear" && (
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Expert Ear Care</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Experiencing ear pain, infections, or hearing loss? MAMS Hospital offers expert diagnosis and
                    treatment for a full range of ear conditions, from common issues like earwax buildup to complex
                    problems like tinnitus, vertigo, and sudden hearing loss.
                  </p>
                   <div className="relative z-10 h-[400px] rounded-xl overflow-hidden shadow-2xl bg-white">
                        <img
                            src="/ear.webp"
                            loading="lazy"
                            alt="ENT Specialist"
                            className="w-full h-full object-cover"
                        />
                        </div>

                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4">We Treat:</h4>
                  <div className="grid grid-cols-1 gap-3">
                    {earConditions.map((condition, index) => (
                      <Link
                        key={index}
                        to={condition.link}
                        className="flex items-center gap-3 p-3 rounded-lg hover:bg-teal-50 transition-colors group"
                      >
                        <CheckCircle2 className="h-5 w-5 text-teal-600 flex-shrink-0" />
                        <span className="text-gray-700 group-hover:text-teal-600 font-medium">{condition.name}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "nose" && (
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Expert Nasal & Sinus Care</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    From allergies and sinusitis to complex structural issues and tumors, MAMS Hospital provides
                    comprehensive diagnosis and treatment for all nasal and sinus conditions. Our specialists offer
                    advanced care for deviated septums, nosebleeds, and more.
                  </p>
              <div className="relative z-10 h-[400px] rounded-xl overflow-hidden shadow-2xl bg-white">
                <img src="/sinus.webp" loading="lazy" className="w-full h-full object-cover" />
                </div>

                 
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4">We Treat:</h4>
                  <div className="grid grid-cols-1 gap-3">
                    {noseConditions.map((condition, index) => (
                      <Link
                        key={index}
                        to={condition.link}
                        className="flex items-center gap-3 p-3 rounded-lg hover:bg-teal-50 transition-colors group"
                      >
                        <CheckCircle2 className="h-5 w-5 text-teal-600 flex-shrink-0" />
                        <span className="text-gray-700 group-hover:text-teal-600 font-medium">{condition.name}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "throat" && (
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">Head & Neck Surgery</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    From airway obstructions and thyroid issues to salivary gland disorders and tonsillectomies, MAMS
                    Hospital provides comprehensive surgical solutions. Our expert ENT surgeons are skilled in
                    procedures ranging from foreign body removal to complex tumor excisions.
                  </p>
                 <div className="relative z-10 h-[400px] rounded-xl overflow-hidden shadow-2xl bg-white">
                    <img src="/throat.webp" loading="lazy" className="w-full h-full object-cover" />
                    </div>

                 </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-4">We Treat:</h4>
                  <div className="grid grid-cols-1 gap-3">
                    {throatConditions.map((condition, index) => (
                      <Link
                        key={index}
                        to={condition.link}
                        className="flex items-center gap-3 p-3 rounded-lg hover:bg-teal-50 transition-colors group"
                      >
                        <CheckCircle2 className="h-5 w-5 text-teal-600 flex-shrink-0" />
                        <span className="text-gray-700 group-hover:text-teal-600 font-medium">{condition.name}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>


     {/* InsuranceSection  */}
      <InsuranceSection />


      {/* WHY CHOOSE */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl grid md:grid-cols-3 gap-6">
          {whyChoose.map((item, i) => (
            <Card key={i}>
              <CardContent className="p-6">
                <item.icon className="w-10 h-10 text-teal-600 mb-4" />
                <h3 className="font-bold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* DOCTORS SLIDER */}
        <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
            <h2 className="text-3xl font-bold text-center mb-10">
            Meet Our ENT Specialists
            </h2>

            <div className="relative">
            
            {/* LEFT BUTTON */}
            <button
                onClick={prevSlide}
                disabled={currentSlide === 0}
                className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 z-10
                w-12 h-12 items-center justify-center rounded-full bg-white shadow
                disabled:opacity-40"
            >
                <ChevronLeft />
            </button>

            {/* SLIDER */}
            <div className="overflow-hidden">
                <div
                className="flex transition-transform duration-500 ease-out"
                style={{
                    transform: `translateX(-${currentSlide * (100 / visibleCards)}%)`,
                }}
                >
                {specialists.map((doc, i) => (
                    <div
                        className={`flex-shrink-0 px-3 ${
                            isMobile ? "w-full" : "w-1/3"
                        }`}
                        >

                    <Card className="h-full">
                        <img
                        src={doc.image}
                        loading="lazy"
                        alt={doc.name}
                        className="w-full h-[336px] object-cover"
                        />
                        <CardContent className="p-4">
                        <h3 className="font-bold">{doc.name}</h3>
                        <p className="text-teal-600">{doc.specialty}</p>
                        <p className="text-sm text-gray-600">
                            {doc.description}
                        </p>
                        </CardContent>
                    </Card>
                    </div>
                ))}
                </div>
            </div>

            {/* RIGHT BUTTON */}
            <button
                onClick={nextSlide}
                disabled={currentSlide === maxSlide}
                className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 z-10
                w-12 h-12 items-center justify-center rounded-full bg-white shadow
                disabled:opacity-40"
            >
                <ChevronRight />
            </button>

            {/* MOBILE BUTTONS */}
            <div className="flex md:hidden justify-center gap-4 mt-6">
                <button
                onClick={prevSlide}
                disabled={currentSlide === 0}
                className="w-10 h-10 rounded-full bg-white shadow"
                >
                <ChevronLeft />
                </button>
                <button
                onClick={nextSlide}
                disabled={currentSlide === maxSlide}
                className="w-10 h-10 rounded-full bg-white shadow"
                >
                <ChevronRight />
                </button>
            </div>

            </div>
        </div>
        </section>

        {/* FAQ Section */}
           <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, i) => (
              <Card key={i} className="p-6">
                <h3 className="font-bold text-gray-900 mb-3 text-lg">{faq.question}</h3>
                <p className="text-gray-700">{faq.answer}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
     <section className="py-16 px-4 bg-primary text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Schedule Your ENT Consultation Today</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Don't let ENT problems affect your quality of life. Our specialists are here to help.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Call Us</h3>
              <a href="tel:+91-7399999981" className="text-white/90 hover:text-white">
                +91-7399999981
              </a>
            </Card>

            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Email Us</h3>
              <a href="mailto:info@mamshospital.com" className="text-white/90 hover:text-white">
                info@mamshospital.com
              </a>
            </Card>

            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Visit Us</h3>
              <p className="text-white/90 text-sm">Miyapur & Bachupally, Hyderabad</p>
            </Card>
          </div>

          {/* <div className="text-center">
            <a href="/book-appointment">
              <button className="px-8 py-3 bg-white text-primary rounded-md hover:bg-white/90 transition font-bold text-lg">
                Book Your Appointment Now
              </button>
            </a>
          </div> */}
        </div>
      </section>

      {/* MAP SECTION */}
{/* MAP SECTION */}
<section className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mt-12">
  <div className="w-full h-[420px] md:h-[450px] overflow-hidden shadow-xl rounded-2xl">
    <iframe
      src="https://www.google.com/maps?q=MAMS+Hospitals+Bachupally&output=embed"
      className="w-full h-full border-0"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="MAMS Hospital Bachupally Map"
    />
  </div>
</section>




        </div>
  )
}
